import React from "react";

export interface SelectProps
  extends React.DetailedHTMLProps<
    React.SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  > {}

const Select: React.FC<SelectProps> = ({ ...props }) => (
  <select className="fl-p-4 fl-rounded-md" {...props} />
);

export default Select;
